<template>
    <v-dialog
        v-model="dialogCreationTask"
        max-width="500px"
    >
        <template v-slot:activator="{ on, attrs }">
        <v-btn
            color="primary"
            dark
            small
            v-bind="attrs"
            v-on="on"
        >
            Créer nouvelle tâche
        </v-btn>
        </template>
        <v-card>
        <v-card-title>
            <span v-if="dataToModify == null" class="text-h5">Ajout nouvelle tâche</span>
            <span v-else class="text-h5">Modification tâche</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeDialog" >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text>
            <v-form ref="formAddTask" v-model="isAddTaskFormValid">
                <v-container>
                    <v-row>
                        <v-col
                            cols="12"
                        >
                            <v-text-field
                            outlined
                            v-model="taskName"
                            label="Nom tâche*"
                            :rules="[checkIsRequired(taskName)]"
                            required
                            hide-details="auto"
                            ></v-text-field>
                        </v-col>
                        <v-col
                        v-if="fieldsToAdd.includes('category')"
                        cols="12"
                        >
                            <v-select
                            outlined
                            v-model="category"
                            label="Catégorie"
                            :items="['Station motrice', 'Station retour']"
                            hide-details="auto"
                            :rules="[checkIsRequired(category)]"
                            >
                            </v-select>
                        </v-col>
                        <v-col
                        v-if="!('lift_id' in toAddOnSave)"
                        cols="12"
                        >
                            <v-autocomplete
                            outlined
                            v-model="lift"
                            label="Appareil concerné"
                            return-object
                            :items="$store.state.liftsStore.liftsList"
                            item-value="lift_id"
                            item-text="lift_name"
                            hide-details="auto"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col
                        v-if="fieldsToAdd.includes('nextAlert') && lift.lift_id"
                        cols="12"
                        >
                            <span class="font-weight-medium">Déclenchement de l'alerte</span>
                            <v-radio-group v-model="alertType" hide-details="auto" class="mt-1">
                                <v-radio label="Aucune alerte" value="none"></v-radio>
                                <v-radio label="Au nombre d'heures d'exploitation de l'appareil" value="hours" :disabled="!lift_last_count_hours"></v-radio>
                                <v-radio label="À une date du calendrier" value="date"></v-radio>
                            </v-radio-group>
                            <span v-if="!lift_last_count_hours" class="text-caption grey--text">
                                L'alerte au nombre d'heures d'exploitation nécessite au moins un registre mentionnant le nombre d'heures de l'appareil.
                            </span>
                        </v-col>
                        <!-- Mode heures d'exploitation -->
                        <template v-if="fieldsToAdd.includes('nextAlert') && lift.lift_id && alertType === 'hours'">
                            <v-col cols="12">
                                <v-text-field
                                outlined
                                :rules="[v => checkIsNumber(v)]"
                                v-model="firstAlert"
                                label="1ère alerte dans X heures d'exploitation"
                                prepend-inner-icon="mdi-wrench-clock"
                                hide-details="auto"
                                ></v-text-field>
                                <span v-if="next_alert_exploit_hours_fix" class="text-caption grey--text">
                                    {{ lift_last_count_hours }}h d'exploitation au {{ lift_date_usage_count_hours }},
                                    donc 1ère alerte à {{ next_alert_exploit_hours_fix }}h.
                                </span>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                outlined
                                :rules="[v => checkIsNumber(v)]"
                                v-model="repetition_default"
                                label="(Optionnel) Répéter toutes les X heures d'exploitation (vide = alerte unique)"
                                prepend-inner-icon="mdi-cog-sync-outline"
                                hide-details="auto"
                                ></v-text-field>
                            </v-col>
                        </template>
                        <!-- Mode date (alerte unique ou récurrente) -->
                        <template v-if="fieldsToAdd.includes('nextAlert') && lift.lift_id && alertType === 'date'">
                            <v-col cols="12">
                                <v-menu
                                    v-model="menu_alert_date"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                        v-model="computedAlertDateFormatted"
                                        label="1ère alerte le"
                                        prepend-inner-icon="mdi-calendar"
                                        readonly
                                        outlined
                                        hide-details="auto"
                                        :rules="[checkIsRequired(alertDate)]"
                                        v-bind="attrs"
                                        v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="alertDate"
                                        locale="fr"
                                        :first-day-of-week="1"
                                        :min="todayISO"
                                        @input="menu_alert_date = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                outlined
                                type="number"
                                min="1"
                                :rules="[v => checkIsStrictlyPositiveOrEmpty(v)]"
                                v-model="recurrence_interval_days"
                                label="(Optionnel) Répéter tous les X jours (vide = alerte unique)"
                                prepend-inner-icon="mdi-calendar-sync"
                                hide-details="auto"
                                ></v-text-field>
                                <span v-if="recurrence_interval_days > 0" class="text-caption grey--text">
                                    Alerte récurrente tous les {{ recurrence_interval_days }} jours, à partir de la date choisie.
                                </span>
                                <span v-else class="text-caption grey--text">Alerte unique à la date choisie.</span>
                            </v-col>
                        </template>
                        <v-col
                            cols="12"
                        >
                            <v-textarea
                            outlined
                            v-model="taskDescription"
                            label="Description"
                            hide-details="auto"
                            ></v-textarea>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="8"
                        >
                            <v-file-input
                            v-model="imageInput"
                            label="Image"
                            filled
                            prepend-icon="mdi-camera"
                            accept=".png, .jpg, .jpeg"
                            @change="selectImage"
                            ></v-file-input>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="4"
                            align= "center"
                        >
                            <v-img width="100px" v-if="previewImage" :src="previewImage" alt=""></v-img>
                            <v-progress-circular v-if="isLoadingImage" indeterminate></v-progress-circular>
                        </v-col>
                        <v-col
                            cols="12"
                            align= "right"
                        >
                            <v-btn color="error" v-if="newImage != undefined" @click="newImage = undefined; imageDeletion = true; imageInput = null">Supprimer image</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            color="blue darken-1"
            text
            @click="closeDialog"
            >
            Annuler
            </v-btn>
            <v-btn
            color="blue darken-1"
            text
            :disabled="!isAddTaskFormValid || isLoadingImage"
            @click="saveCreationTask"
            >
            Sauvegarder
            </v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {compressAccurately} from 'image-conversion';
export default {
    name: "DialogCreateTask",
    props: {
        dispatcherOnSave: String,
        toAddOnSave: Object,
        fieldsToAdd: {
            type: Array,
            default(){
                return []
            }
        },
        dataToModify: Object,
    },
    data() {
        return {
            lift_temp: {lift_id: null},
            task_id: null,
            category: 'Station motrice',
            taskName: null,
            taskDescription: null,
            repetition_default: null,
            firstAlert: null,
            recurrence_interval_days: null,
            alertType: 'none',
            alertDate: null,
            menu_alert_date: false,
            isAddTaskFormValid: false,
            dialogCreationTask: false,
            newImage: undefined,
            imageData: null,
            imageDeletion: false,
            imageInput: null,
            isLoadingImage: false,
        }
    },
    computed: {
        lift: {
            get(){
                return this.lift_temp.lift_id == null ? this.$store.state.liftsStore.selectedLiftCentral : this.lift_temp
            },
            set(newValue){
                this.lift_temp = newValue
            }
        } ,
        lift_last_count_hours(){
            return this.lift && 'last_count_hours' in this.lift ? this.lift.last_count_hours : ''
        },
        lift_date_usage_count_hours(){
            return this.lift && 'date_usage_count_hours' in this.lift ? this.lift.date_usage_count_hours : ''
        },
        next_alert_exploit_hours_fix(){
            return this.firstAlert == null ? null : Number(this.lift_last_count_hours) + Number(this.firstAlert)
        },
        todayISO(){
            return (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
        },
        computedAlertDateFormatted(){
            if(!this.alertDate) return ''
            const [year, month, day] = this.alertDate.split('-')
            const monthList = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre']
            return (day + ' ' + monthList[month - 1] + ' ' + year)
        },
        previewImage() {
            if (this.newImage != undefined) {
                return this.newImage
            } 
            /*else if (this.oldAvatar != "None" && this.oldAvatar != "") {
                return axiosInstance.defaults.baseURL + "/dataLogged/avatars/"+this.oldAvatar+"/"+this.$store.state.authStore.loginToken
            }*/
            return false
        },
    },
    watch: {
        //We use a watch because dialogCreationTask can be set to false with calling close if we click outside box
        dialogCreationTask(val){
            if(!val){
                this.$emit('closeCreationTask')
                this.lift_temp = {lift_id: null}
                this.category = 'Station motrice'
                this.taskDescription = null
                this.repetition_default = null
                this.firstAlert = null
                this.recurrence_interval_days = null
                this.alertType = 'none'
                this.alertDate = null
                this.menu_alert_date = false
                this.taskName = null
                this.task_id = null
                this.imageData= null
                this.newImage= undefined
                this.imageDeletion = false
                this.imageInput = null
            }
        },
        dataToModify(val){
            if(val != null){
                this.dialogCreationTask = true
                this.taskName = val['title']
                this.taskDescription = val['description']
                this.task_id = val['task_id']
                if(this.fieldsToAdd.includes('category')){
                    this.category = val['category']
                }
                if(this.fieldsToAdd.includes('nextAlert')){
                    // Déduit le mode d'alerte des champs renseignés (un seul à la fois)
                    if(val['recurrence_interval_days'] != null || val['next_alert_date']){
                        this.alertType = 'date'
                        this.alertDate = val['next_alert_date'] ? String(val['next_alert_date']).substr(0, 10) : null
                        this.recurrence_interval_days = val['recurrence_interval_days']
                    } else if(val['next_alert_exploitation_hours'] != null || val['repetition_default'] != null){
                        this.alertType = 'hours'
                        this.repetition_default = val['repetition_default']
                    } else {
                        this.alertType = 'none'
                    }
                }
                this.newImage = val['image']
            }
        }
    },
    methods: {
        checkIsRequired(value, errorMessage) {
            if (!errorMessage) {
                errorMessage = "Ce champ est nécessaire";
            }
            return !!value || errorMessage;
        },
        async saveCreationTask() {
            let payload = this.toAddOnSave
            if(!('lift_id' in this.toAddOnSave)){
                payload['lift_id'] = this.lift.lift_id
            }
            payload['title'] = this.taskName
            payload['description'] = this.taskDescription
            payload['task_id'] = this.task_id
            payload['image'] = this.imageData
            payload['imageDeletion'] = this.imageDeletion
            if(this.fieldsToAdd.includes('nextAlert')){
                // Un seul mode d'alerte est renseigné, les autres champs restent à null
                if(this.alertType === 'hours'){
                    payload['repetition'] = this.repetition_default
                    payload['next_alert'] = this.next_alert_exploit_hours_fix
                    payload['next_alert_date'] = null
                    payload['recurrence_interval_days'] = null
                } else if(this.alertType === 'date'){
                    payload['next_alert_date'] = this.alertDate
                    payload['recurrence_interval_days'] = (this.recurrence_interval_days === '' || this.recurrence_interval_days == null) ? null : Number(this.recurrence_interval_days)
                    payload['repetition'] = null
                    payload['next_alert'] = null
                } else {
                    payload['repetition'] = null
                    payload['next_alert'] = null
                    payload['next_alert_date'] = null
                    payload['recurrence_interval_days'] = null
                }
            }
            if(this.fieldsToAdd.includes('category')){
                payload['category'] = this.category
            }
            await this.$store.dispatch(this.dispatcherOnSave, payload).then(() => {
                this.dialogCreationTask = false
            })
        },
        checkIsNumber(value, errorMessage) {
            if (errorMessage == null) {
                errorMessage = 'La valeur doit être un nombre. Ex: 15'
            }
            return (value >= 0) || (value == null) || errorMessage
        },
        checkIsStrictlyPositiveOrEmpty(value, errorMessage) {
            if (errorMessage == null) {
                errorMessage = 'Le nombre de jours doit être un entier positif. Ex: 30'
            }
            return (value == null) || (value === '') || (Number.isInteger(Number(value)) && Number(value) > 0) || errorMessage
        },
        closeDialog(){
            this.dialogCreationTask = false
        },
        selectImage(image){
            this.isLoadingImage = true
            compressAccurately(image,600).then(res=>{
                const imageCompressed = res
                const reader = new FileReader();
                reader.addEventListener("load", () => {
                    // convert image file to base64 string
                    this.imageData = reader.result;
                    this.newImage = URL.createObjectURL(imageCompressed)
                }, false);
                this.imageDeletion = false
                reader.readAsDataURL(imageCompressed)
                this.isLoadingImage = false        
            })
        }
    }
}
</script>